import {Container} from 'pixi.js';
import {graphic} from "../../Graphic";
import {Entity} from "../Entity";
import {EntityLabel} from "./../EntityLabel";
import {RowSequence} from "./RowSequence";
import {RowCurve} from "./RowCurve";
import {RowService} from "./RowService";
import {GraphicItemService} from "./GraphicItemService";

export class Row extends Entity {

    static size = 12;

    static margin = 3;

    static defaultBackgroundColor = '0x333333';

    static showLabels = true;

    static labelStyle = {
        fill: 0xBD3D3A,
        align: 'right',
        fontSize: 16
    };

    static getSeatReference(row, index) {
        const seatLabel = row.sequence.labels[index].text;
        const rowLabel = row.label.value;
        return rowLabel + '-' + seatLabel;
    }

    constructor({
        id = null,
        category = null,
        curve = 0,
        sequence = 1,
        sequenceOffset = 1,
        labelDisplay = 'left',
        container,
        graphicItems,
        label
    }) {
        super({
            id,
            container,
            graphicItems,
            type: 'row',
            enableCacheAsBitmap: false
        });

        this.category = category;
        this.sequenceOffset = sequenceOffset;
        this.seatsContainer = new Container();
        this.sequence = new RowSequence(this, sequence, sequenceOffset);
        this.curve = new RowCurve(this, curve);
        this.label = new EntityLabel(this, label, labelDisplay);
        this.graphicItemsCategories = []
    }

    clone() {
        return RowService.createFromProps(this.getProps())
    }

    getProps() {
        const prevZoom = graphic.zoom;
        graphic.setZoom({value: 1});

        const length = this.graphicItems.length;
        const props = super.getProps();

        graphic.setZoom({value: prevZoom});
        return {
            ...props,
            length,
            label: this.label.value,
            curve: this.curve.value,
            sequence: this.sequence.type,
            sequenceDirection: this.sequence.direction,
            sequenceOffset: this.sequence.offset,
            categoryId: this.category ? this.category.id : null,
            category: this.category,
            labelDisplay: this.label.display
        }
    }

    draw() {
        super.draw(
            graphic.container.children.length,
            this.seatsContainer
        );
        this.container.addChild(this.seatsContainer);
        if (Row.showLabels) this.label.draw();

        this.sequence.updateLabelsValue();
        this.sequence.updateLabelsPosition();
    }

    destroy() {
        super.destroy(this.seatsContainer);
        this.container.removeChild(this.seatsContainer);
        this.label.destroy();
    }

    updateFromProps(rowProps, bindProps = null) {
        super.updateFromProps(
            rowProps,
            bindProps,
            props => RowService.createFromProps(props),
            newEntity => {
                this.category = newEntity.category;
                this.label = newEntity.label;
                this.curve = newEntity.curve;
                this.length = newEntity.length;
                this.seatsContainer = newEntity.seatsContainer;
                this.sequence = newEntity.sequence;
                this.curve = newEntity.curve;
            }
        )
    }

    setCategory(category) {
        this.category = category;

        this.graphicItems.forEach(graphicItem =>
            GraphicItemService.setGraphicItemColor(graphicItem, category.color)
        );
    }

    setSeatsCount(value) {
        this.updateFromProps({
            ...this.getProps(),
            length: parseInt(value)
        });
    }

    setSeatCategory({index, label}, categoryId, categories) {
        const category = categories.find(category => category.id === categoryId);
        this.graphicItems.forEach((graphicItem, i) => {
            if (index && index === i) {
                this.graphicItemsCategories[i] = category
                GraphicItemService.setGraphicItemColor(graphicItem, category.color);
            }
            if (label && label === this.sequence.labels[i].text) {
                this.graphicItemsCategories[i] = category
                GraphicItemService.setGraphicItemColor(graphicItem, category.color);
            }
        });
    }

    getGraphicItemCategory(i) {
        return typeof this.graphicItemsCategories[i] !== 'undefined'
            ? this.graphicItemsCategories[i].id
            : this.category.id;
    }
}